<template>
<articel />
</template>

<script>
export default{
    name:'articelG'
}

</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/articelG.vue